module.exports = __webpack_public_path__ + "img/about-us-4.3513aead.jpg";